






import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

export default defineComponent({
  setup(props, context){

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      const school_id = context.root.$store.state.currentUser.school_id;
      const nendo = context.root.$store.state.nendo;
      const exec_times = context.root.$store.state.exec_times;

      if(school_id && nendo && exec_times){
        window.location.href = `/#/${school_id}/candidate/${nendo}/${exec_times}/sign_in`;
      }
    });
  }
})
